import {
  DDC_ADHERENT_STAFF_ROLES,
  DIPLOMES_MARIN,
  DIPLOMES_MARIN_SGDF,
  PARAMETRES_ADHERENT_SOUTIEN
} from '../constant/constant';
import { IAdherentDiplome, IAdherentInformations, IAdherentQualification } from '../model/adherent-informations.model';
import { TypeSoutienEnum } from '../constant/enum';
import { IAdherent } from '../model/adherent.model';
import { ITypeCamp } from '../model/type-camp.model';

export function getDdcAdherentStaffRoleIcon(roleStaff: string) {
  if(roleStaff) {
    const ddcAdherentStaffRole = DDC_ADHERENT_STAFF_ROLES.find(ddcAdherentStaffRole => roleStaff == ddcAdherentStaffRole.value);
    if(ddcAdherentStaffRole) return ddcAdherentStaffRole.icon;
  }
  return null;
}

export function getDdcAdherentSoutienIcon(typeSoutien: TypeSoutienEnum) {
  const parametresAdherentAoutien = PARAMETRES_ADHERENT_SOUTIEN.find(parametresAdherentSoutien => parametresAdherentSoutien.typeSoutien == typeSoutien);
  return parametresAdherentAoutien ? parametresAdherentAoutien.icon : '';
}
export function getAdherentDiplomesMarin(numeroAdherent: number, adherentInformations: IAdherentInformations[]) {
  let filteredAdherentDiplomes: IAdherentDiplome[] = [];
  if(numeroAdherent && adherentInformations[numeroAdherent] && adherentInformations[numeroAdherent].adherentDiplomes) {
    const adherentDiplomes = adherentInformations[numeroAdherent].adherentDiplomes;
    if(adherentDiplomes && adherentDiplomes.length > 0) {
      filteredAdherentDiplomes =
          adherentDiplomes.filter((adherentDiplome: IAdherentDiplome) => DIPLOMES_MARIN_SGDF.includes(adherentDiplome.type));
    }
  }
  return filteredAdherentDiplomes;
}

export function getAdherentDiplomesMarinLabel(numeroAdherent: number, adherentInformations: IAdherentInformations[]) {
  const adherentDiplomesMarin = getAdherentDiplomesMarin(numeroAdherent, adherentInformations);
  const adherentDiplomesMarinTitles = adherentDiplomesMarin ? adherentDiplomesMarin.map((diplome: IAdherentDiplome) => {
    return diplome.type;
  }) : [];
  return adherentDiplomesMarinTitles.join(", ");
}

export function getAdherentQualificationLabel(numeroAdherent: string, adherentsInformations: IAdherentInformations[]) {
  if (numeroAdherent && adherentsInformations[numeroAdherent] && adherentsInformations[numeroAdherent].adherentQualifications) {
    const adherentQualifications = adherentsInformations[numeroAdherent].adherentQualifications;

    let qualification: string = '';

    const regExpDSF = new RegExp('DSF', 'g');
    const now = new Date();
    const adherentQualificationsDSF = adherentQualifications.filter((adherentQualification: IAdherentQualification) => adherentQualification.type.match(regExpDSF));
    if (adherentQualificationsDSF && adherentQualificationsDSF.length > 0) {
      let stagiare: boolean = true;
      let qualificationValidity: boolean = false;
      adherentQualificationsDSF.forEach((adherentQualification: IAdherentQualification) => {
        if(adherentQualification.dateFin == null || new Date(adherentQualification.dateFin.format("YYYY-MM-DD")) > now) {
          qualificationValidity = true;
          if(adherentQualification.estTitulaire === true) {
            stagiare = false;
          }
        }

        if(!!qualificationValidity) {
          qualification = stagiare == true ? 'DSF(s)' : 'DSF';
        }
      });
    }
    const regExpASF = new RegExp('ASF', 'g');
    const adherentQualificationsASF = adherentQualifications.filter((adherentQualification: IAdherentQualification) => adherentQualification.type.match(regExpASF));
    if (adherentQualificationsASF && adherentQualificationsASF.length > 0) {
      let stagiare: boolean = true;
      let qualificationValidity: boolean = false;
      adherentQualificationsASF.forEach((adherentQualifASF: IAdherentQualification) => {
        if(adherentQualifASF.dateFin == null || new Date(adherentQualifASF.dateFin.format("YYYY-MM-DD")) > now) {
          qualificationValidity = true;
          if(adherentQualifASF.estTitulaire) {
            stagiare = false;
          }
        }
      });
      if(qualificationValidity) {
        if (qualification.length > 0) {
          qualification += stagiare == true ? ' - ASF(s)' : ' - ASF';
        } else {
          qualification = stagiare == true ? 'ASF(s)' : 'ASF';
        }
      }
    }
    return qualification;
  }
  return '';
}

export function compareAdherents(param1: IAdherent, param2: IAdherent) {
  return param1 && param2 ? param1.numero == param2.numero : false;
}
